import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  getPageBySlug,
  getAllArticlesByPage,
} from "../services/pagesPersonnaliseesServices";
import useScrollToTop from "./../hooks/useScollToTop";

const PagePersonnalisee = () => {
  useScrollToTop();
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const pageData = await getPageBySlug(slug);
      setPage(pageData);
      const articlesData = await getAllArticlesByPage(pageData.id);
      setArticles(articlesData);
    };
    fetchData();
  }, [slug]);

  if (!page) return <div>Chargement...</div>;

  return (
    <div className="container mx-auto pt-[150px] px-4 mb-10 font-montserrat">
      <h1 className="text-4xl md:text-5xl font-bold text-center mb-6">
        {page.titre}
      </h1>

      {page.introduction && (
        <div
          className="prose prose-lg text-center mx-auto dark:prose-invert mb-12 max-w-3xl"
          dangerouslySetInnerHTML={{ __html: page.introduction }}
        />
      )}

      <div className="space-y-20 mb-10">
        {articles.map((article, index) => (
          <div
            key={article.id}
            className={`flex flex-col ${
              article.url_image && article.contenu_texte
                ? "md:flex-row"
                : "flex-col"
            } ${
              index % 2 !== 0 && article.url_image && article.contenu_texte
                ? "md:flex-row-reverse"
                : ""
            } items-center gap-8`}
          >
            {article.url_image && article.contenu_texte && (
              <>
                <div className="w-full md:w-1/2">
                  <img
                    src={article.url_image}
                    alt={article.titre_article}
                    className="w-full rounded-xl shadow-lg transition-transform duration-300 hover:scale-105"
                  />
                </div>
                <div className="w-full md:w-1/2 bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                  <h2 className="text-2xl md:text-3xl font-semibold mb-4 text-primary dark:text-orange-400">
                    {article.titre_article}
                  </h2>
                  <div
                    className="prose dark:prose-invert max-w-none"
                    dangerouslySetInnerHTML={{ __html: article.contenu_texte }}
                  />
                </div>
              </>
            )}

            {article.url_image && !article.contenu_texte && (
              <div className="w-full">
                <img
                  src={article.url_image}
                  alt={article.titre_article}
                  className="w-full rounded-xl shadow-lg transition-transform duration-300 hover:scale-105"
                />
              </div>
            )}

            {!article.url_image && article.contenu_texte && (
              <div className="w-full bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <h2 className="text-2xl md:text-3xl font-semibold mb-4 text-primary dark:text-orange-400">
                  {article.titre_article}
                </h2>
                <div
                  className="prose dark:prose-invert max-w-none"
                  dangerouslySetInnerHTML={{ __html: article.contenu_texte }}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PagePersonnalisee;
